{
  "Shared": {
    "navigationBlocker": {
      "title": "Nespremljene promjene",
      "description": "Imate nespremljene promjene koje će biti izgubljene ako napustite ovu stranicu. Jeste li sigurni da želite nastaviti?",
      "cancel": "Otkaži",
      "confirm": "Napusti stranicu"
    }
  },
  "Common": {
    "noImage": "Nema slike",
    "soldOut": "Rasprodano",
    "sale": "Akcija",
    "loading": "Učitavanje...",
    "error": "Došlo je do greške",
    "retry": "Pokušaj ponovo",
    "back": "Natrag",
    "inviteTitle": "Pozovi ljude u Postolar Varga",
    "inviteDescription": "Poznajete nekoga tko bi volio naše proizvode? Podijelite s njima!",
    "inviteButton": "Podijeli",
    "previous": "Prethodno",
    "next": "Sljedeće",
    "basePrice": "Bazna cijena"
  },
  "Footer": {
    "about": {
      "title": "O nama",
      "description": "Proizvodimo visoko-udobne kožne papuče s anatomskim potplatom koji olakšava bol u nogama, listovima, petama i petnom trnu. Prirodna koža i ručni rad jamče vrhunske anatomske papuče po pristupačnim cijenama. Također nudimo i izradu torbi, remenja i ostalih predmeta od kože."
    },
    "information": {
      "title": "Informacije",
      "aboutUs": "O nama",
      "deliveryInfo": "Informacije o dostavi",
      "privacyPolicy": "Pravila privatnosti",
      "termsAndConditions": "Opći uvjeti kupnje",
      "contactUs": "Kontakt",
      "returns": "Pravila povrata",
      "paymentOptions": "Načini plaćanja",
      "faq": "Često postavljana pitanja",
      "withdrawal": "Raskid ugovora",
      "withdrawalForm": "Obrazac za raskid ugovora",
      "complaints": "Prigovori i reklamacije",
      "cookies": "Kolačići",
      "cookieSettings": "Postavke kolačića",
      "priceList": "Cjenik",
      "legalNotice": "Pravna obavijest"
    },
    "customerSupport": {
      "title": "Korisnička podrška",
      "siteMap": "Mapa stranice",
      "orderHistory": "Povijest narudžbi",
      "wishList": "Lista želja",
      "giftCards": "Poklon bonovi",
      "specialOffers": "Akcije",
      "newsletter": "Newsletter"
    },
    "social": {
      "title": "Društvene mreže",
      "followOnInstagram": "Pratite na Instagramu",
      "followOnFacebook": "Pratite na Facebooku"
    },
    "copyright": "© {{year}} Postolar Varga. Sva prava pridržana."
  },
  "StaticPages": {
    "AboutUs": {
      "title": "O nama",
      "content": "Proizvodimo visoko-udobne kožne papuče s anatomskim potplatom koji olakšava bol u nogama, listovima, petama i petnom trnu. Prirodna koža i ručni rad jamče vrhunske anatomske papuče po pristupačnim cijenama. Također nudimo i izradu torbi, remenja i ostalih predmeta od kože."
    },
    "breadcrumbs": {
      "home": "Početna"
    },
    "onThisPage": "Na ovoj stranici",
    "groups": {
      "information": "Informacije",
      "legal": "Pravne informacije"
    }
  },
  "Account": {
    "title": "Moj račun",
    "backToAccount": "Natrag na račun",
    "orders": {
      "title": "Narudžbe",
      "description": "Pregledajte povijest narudžbi i pratite pošiljke",
      "empty": "Još niste napravili nijednu narudžbu.",
      "startShopping": "Počni kupovati",
      "orderNumber": "Narudžba",
      "items": "{{count}} artikl(a)",
      "viewDetails": "Pogledaj detalje",
      "loadMore": "Učitaj više",
      "loading": "Učitavanje…",
      "backToOrders": "Natrag na narudžbe",
      "status": "Status narudžbe",
      "statusProcessing": "U obradi",
      "orderItems": "Artikli narudžbe",
      "shippingAddress": "Adresa dostave",
      "orderSummary": "Pregled narudžbe",
      "subtotal": "Međuzbroj",
      "shipping": "Dostava",
      "tax": "PDV",
      "total": "Ukupno",
      "tracking": "Praćenje pošiljke",
      "trackingNumber": "Broj pošiljke",
      "notFound": "Narudžba nije pronađena.",
      "financialStatuses": {
        "AUTHORIZED": "Autorizirano",
        "EXPIRED": "Isteklo",
        "PAID": "Plaćeno",
        "PARTIALLY_PAID": "Djelomično plaćeno",
        "PARTIALLY_REFUNDED": "Djelomično vraćeno",
        "PENDING": "Na čekanju",
        "REFUNDED": "Vraćeno",
        "VOIDED": "Poništeno"
      },
      "fulfillmentStatuses": {
        "FULFILLED": "Isporučeno",
        "IN_PROGRESS": "U tijeku",
        "ON_HOLD": "Zadržano",
        "OPEN": "Otvoreno",
        "PARTIALLY_FULFILLED": "Djelomično isporučeno",
        "PENDING_FULFILLMENT": "Na čekanju isporuke",
        "READY_FOR_DELIVERY": "Spremno za dostavu",
        "READY_FOR_PICKUP": "Spremno za preuzimanje",
        "RESTOCKED": "Ponovno na stanju",
        "SCHEDULED": "Zakazano",
        "UNFULFILLED": "Nije isporučeno"
      }
    },
    "addresses": {
      "title": "Adrese",
      "description": "Upravljajte adresama za dostavu i naplatu",
      "empty": "Nemate spremljenih adresa.",
      "addFirst": "Dodajte prvu adresu",
      "addNew": "Dodaj adresu",
      "default": "Zadana",
      "edit": "Uredi",
      "delete": "Obriši",
      "setDefault": "Postavi kao zadanu",
      "editTitle": "Uredi adresu",
      "addTitle": "Dodaj novu adresu",
      "firstName": "Ime",
      "lastName": "Prezime",
      "company": "Tvrtka",
      "address1": "Adresa",
      "address2": "Dodatna adresa",
      "city": "Grad",
      "zip": "Poštanski broj",
      "territoryCode": "Država",
      "territoryCodeHint": "Odaberite državu iz popisa",
      "countryPlaceholder": "Odaberite državu…",
      "countryLoading": "Učitavanje država…",
      "countryNoResults": "Nema rezultata",
      "zoneCode": "Regija / županija (ISO kod)",
      "zoneCodeHint": "npr. 21 za Split",
      "phoneNumber": "Telefon",
      "setAsDefault": "Postavi kao zadanu adresu",
      "save": "Spremi",
      "cancel": "Odustani",
      "saving": "Spremanje…",
      "saved": "Adresa spremljena",
      "saveError": "Greška prilikom spremanja adrese",
      "deleteConfirm": "Jeste li sigurni?",
      "deleteYes": "Da, obriši",
      "deleted": "Adresa obrisana",
      "deleteError": "Greška prilikom brisanja",
      "defaultSet": "Zadana adresa postavljena",
      "defaultSetError": "Greška prilikom postavljanja zadane adrese",
      "unsavedChanges": "Imate nespremljene promjene. Napustiti?",
      "errorCodes": {
        "ADDRESS1_MISSING": "Adresa je obavezna.",
        "ADDRESS_ARGUMENT_EMPTY": "Podaci o adresi su prazni.",
        "ADDRESS_ID_DOES_NOT_EXIST": "Adresa ne postoji.",
        "CONTAINS_HTML_TAGS": "Polje sadrži nedozvoljene HTML oznake.",
        "COUNTRY_NOT_EXIST": "Odabrana država ne postoji.",
        "CUSTOMER_ADDRESS_ALREADY_EXISTS": "Ova adresa je već spremljena.",
        "DELETING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED": "Zadanu adresu ne možete obrisati. Prvo postavite drugu adresu kao zadanu.",
        "DEMOTING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED": "Zadanu adresu nije moguće ukloniti kao zadanu.",
        "INVALID": "Neispravno polje.",
        "INVALID_FOR_COUNTRY": "Vrijednost nije ispravna za odabranu državu.",
        "INVALID_FOR_COUNTRY_AND_PROVINCE": "Vrijednost nije ispravna za odabranu državu i regiju.",
        "INVALID_TERRITORY_CODE": "Neispravna oznaka države.",
        "PHONE_NUMBER_NOT_VALID": "Neispravan broj telefona.",
        "REQUIRED": "Polje je obavezno.",
        "TERRITORY_CODE_MISSING": "Država je obavezna.",
        "TOO_LONG": "Vrijednost je predugačka.",
        "ZONE_CODE_MISSING": "Regija je obavezna."
      }
    },
    "profile": {
      "title": "Profil",
      "description": "Ažurirajte osobne podatke",
      "firstName": "Ime",
      "lastName": "Prezime",
      "email": "Email",
      "phone": "Telefon",
      "newsletter": "Pretplatite se na newsletter za ekskluzivne ponude",
      "save": "Spremi promjene",
      "cancel": "Odustani",
      "saving": "Spremanje…",
      "saved": "Promjene spremljene",
      "saveError": "Greška prilikom spremanja",
      "emailReadOnly": "Email se ne može mijenjati ovdje. Kontaktirajte podršku.",
      "phoneReadOnly": "Telefon se ne može mijenjati ovdje.",
      "unsavedChanges": "Imate nespremljene promjene. Napustiti stranicu?"
    },
    "logout": {
      "title": "Odjava",
      "description": "Odjavite se s računa"
    },
    "countries": {
      "AT": "Austrija",
      "BE": "Belgija",
      "BG": "Bugarska",
      "CY": "Cipar",
      "CZ": "Češka",
      "DE": "Njemačka",
      "DK": "Danska",
      "EE": "Estonija",
      "ES": "Španjolska",
      "FI": "Finska",
      "FR": "Francuska",
      "GR": "Grčka",
      "HR": "Hrvatska",
      "HU": "Mađarska",
      "IE": "Irska",
      "IT": "Italija",
      "LT": "Litva",
      "LU": "Luksemburg",
      "LV": "Latvija",
      "MT": "Malta",
      "NL": "Nizozemska",
      "PL": "Poljska",
      "PT": "Portugal",
      "RO": "Rumunjska",
      "SE": "Švedska",
      "SI": "Slovenija",
      "SK": "Slovačka"
    }
  },
  "Auth": {
    "completingLogin": "Prijava u tijeku…",
    "login": {
      "title": "Prijava",
      "email": "Email",
      "emailPlaceholder": "Unesite svoj email",
      "password": "Lozinka",
      "passwordPlaceholder": "Unesite svoju lozinku",
      "rememberMe": "Zapamti me",
      "forgotPassword": "Zaboravili ste lozinku?",
      "submit": "Prijavi se",
      "noAccount": "Nemate račun?",
      "signUp": "Registrirajte se"
    },
    "register": {
      "title": "Kreiraj račun",
      "firstName": "Ime",
      "lastName": "Prezime",
      "email": "Email",
      "password": "Lozinka",
      "passwordHint": "Lozinka mora imati najmanje 8 znakova",
      "confirmPassword": "Potvrdite lozinku",
      "terms": "Slažem se s",
      "termsLink": "Uvjetima korištenja",
      "and": "i",
      "privacyLink": "Politikom privatnosti",
      "newsletter": "Pretplatite se na naš newsletter za novosti i ponude",
      "submit": "Kreiraj račun",
      "hasAccount": "Već imate račun?",
      "signIn": "Prijavite se"
    },
    "forgotPassword": {
      "title": "Zaboravljena lozinka",
      "description": "Unesite svoju email adresu i poslat ćemo vam link za resetiranje lozinke.",
      "email": "Email",
      "emailPlaceholder": "Unesite svoj email",
      "submit": "Pošalji link za reset",
      "backToLogin": "Natrag na prijavu"
    }
  },
  "Blog": {
    "title": "Blog",
    "subtitle": "Savjeti za zdravlje stopala i noge",
    "readMore": "Pročitaj više",
    "publishedAt": "Objavljeno",
    "author": "Autor",
    "relatedArticles": "Povezani članci",
    "backToBlog": "Natrag na blog",
    "noArticles": "Trenutno nema objavljenih članaka.",
    "breadcrumbs": {
      "home": "Naslovnica",
      "blog": "Blog"
    },
    "shareArticle": "Podijeli članak",
    "tableOfContents": "Sadržaj",
    "minuteRead": "min čitanja",
    "tags": "Oznake",
    "latestArticles": "Najnoviji članci",
    "emptyTitle": "Nema članaka",
    "emptySubtitle": "Trenutno nema objavljenih članaka.",
    "articleNotFound": "Članak nije pronađen",
    "shopAnatomic": "Pogledaj anatomske papuče",
    "ctaTitle": "Više udobnosti za vaša stopala uz anatomske papuče",
    "viewProduct": "Pogledaj proizvod"
  },
  "Cart": {
    "title": "Košarica",
    "item": "artikl",
    "items": "artikli",
    "emptyTitle": "Vaša košarica je prazna",
    "empty": "Vaša košarica je prazna",
    "continueShopping": "Nastavi kupovati",
    "removeItem": "Ukloni artikl",
    "orderSummary": "Pregled narudžbe",
    "subtotal": "Međuzbroj",
    "totalVatIncl": "Ukupno (PDV uključen)",
    "shipping": "Dostava",
    "calculatedAtCheckout": "Izračunava se pri naplati",
    "total": "Ukupno",
    "checkout": "Nastavi na naplatu",
    "shoesColorNotice": "Trudimo se da fotografije proizvoda što vjernije prikazuju boje i izgled kože, no s obzirom na to da koristimo pravu kožu te redovito nabavljamo istu, moguće su manje razlike u nijansama boja u odnosu na prikazanu fotografiju. Takve razlike su karakteristika prirodnog materijala i ne utječu na kvalitetu ili izgled proizvoda.",
    "noteLabel": "Napomena za narudžbu",
    "notePlaceholder": "Napišite napomenu, posebne upute za dostavu ili poruku...",
    "optionName_Size": "Veličina",
    "optionName_Color": "Boja",
    "optionName_Material": "Materijal",
    "optionName_Style": "Stil",
    "optionName_Shoe size": "Veličina",
    "checkoutConfirmation": {
      "title": "Prije završetka narudžbe",
      "message": "Prije završetka narudžbe želimo Vas obavijestiti da uvijek imamo dostupnih modela u svim brojevima za brzu isporuku.",
      "contactPrompt": "Za pregled trenutno dostupnih modela, slobodno nas kontaktirajte na:",
      "phone": "099 280 7007",
      "email": "postolar.varga@gmail.com",
      "helpOffer": "Rado ćemo Vam poslati fotografije i pomoći pri odabiru.",
      "continueToCheckout": "Nastavi na naplatu",
      "cancel": "Natrag"
    },
    "deliveryInfo": {
      "title": "Rok isporuke:",
      "standard": "Rok izrade i isporuke je 7–14 radnih dana.",
      "personalized": "Svaka papuča je ručni rad, pa izrada ponekad može potrajati nešto dulje kako bismo zadržali udobnost i kvalitetu. Hvala vam na strpljenju."
    }
  },
  "Collections": {
    "title": "Kolekcije",
    "breadcrumbs": {
      "home": "Početna",
      "collections": "Kolekcije"
    },
    "productCount": "{{count}} proizvoda",
    "empty": "Nema proizvoda u ovoj kolekciji.",
    "emptyTitle": "Nema pronađenih kolekcija",
    "emptySubtitle": "Provjerite kasnije za nove kolekcije.",
    "notFound": "Kolekcija nije pronađena",
    "backToCollections": "Natrag na kolekcije",
    "loadMore": "Učitaj više proizvoda",
    "showMore": "Prikaži više",
    "showLess": "Prikaži manje",
    "subtitle": "Ručno izrađene papuče, sandale i kožna galanterija"
  },
  "Filters": {
    "filter": "Filter",
    "resetFilters": "Poništi sve",
    "showFilters": "Prikaži filtere",
    "hideFilters": "Sakrij filtere",
    "activeFilters": "Aktivni filteri",
    "clearAll": "Očisti sve",
    "noResults": "Nema proizvoda koji odgovaraju odabranim filterima.",
    "noResultsHint": "Pokušajte ukloniti neke filtere ili proširiti pretragu.",
    "resultsCount_one": "{{count}} proizvod",
    "resultsCount_few": "{{count}} proizvoda",
    "resultsCount_other": "{{count}} proizvoda",
    "productType": {
      "title": "Vrsta proizvoda",
      "handmadeShoes": "Ručno izrađene cipele",
      "personalizedShoes": "Personalizirane cipele",
      "slippers": "Kožne papuče",
      "sandals": "Sandale",
      "belts": "Remeni",
      "bags": "Torbe",
      "backpacks": "Ruksaci",
      "purseBags": "Torbice",
      "keychains": "Privjesci za ključeve",
      "eyewearCases": "Futrole za naočale",
      "petAccessories": "Oprema za ljubimce",
      "groups": {
        "shoes": "Cipele",
        "sandals": "Sandale",
        "bags": "Torbe",
        "backpacks": "Ruksaci",
        "leatherGoods": "Kožna galanterija",
        "belts": "Remeni",
        "eyewearCases": "Futrole za naočale",
        "keychains": "Privjesci za ključeve",
        "pets": "Ljubimci"
      }
    },
    "color": {
      "title": "Boja",
      "black": "Crna",
      "white": "Bijela",
      "red": "Crvena",
      "blue": "Plava",
      "green": "Zelena",
      "yellow": "Žuta",
      "pink": "Ružičasta",
      "brown": "Smeđa",
      "gray": "Siva",
      "navy": "Mornarsko plava",
      "beige": "Bež",
      "silver": "Srebrna",
      "multicolor": "Višebojna",
      "floral": "Cvjetni uzorak",
      "geometric": "Geometrijski uzorak",
      "animal": "Životinjski uzorak",
      "clear": "Prozirna"
    },
    "size": {
      "title": "Veličina",
      "oneSize": "Jedna veličina"
    },
    "price": {
      "title": "Cijena",
      "min": "Min",
      "max": "Maks",
      "range": "{{min}} – {{max}}"
    },
    "gender": {
      "title": "Spol",
      "female": "Žene",
      "male": "Muškarci",
      "unisex": "Unisex"
    },
    "brands": "Marke",
    "vendors": "Kolekcije",
    "sort": "Sortiraj",
    "sortOptions": {
      "default": "Zadano",
      "best-selling": "Najprodavanije",
      "price-asc": "Cijena: niska → visoka",
      "price-desc": "Cijena: visoka → niska",
      "newest": "Najnovije",
      "title-asc": "Naziv: A → Ž",
      "title-desc": "Naziv: Ž → A"
    },
    "availability": "Dostupnost",
    "inStock": "Samo na zalihi",
    "mobile": {
      "title": "Filteri",
      "showResults": "Prikaži rezultate ({{count}})"
    }
  },
  "Homepage": {
    "loading": "Učitavanje...",
    "shopNow": "Kupuj sada",
    "viewAll": "Pogledaj sve",
    "noProducts": "Nema pronađenih proizvoda",
    "topCategories": "Najbolje kategorije",
    "topSellers": "Najprodavaniji",
    "newProducts": "Novi proizvodi",
    "bestSellers": "Najprodavanije",
    "latestArticles": "Najnoviji članci",
    "readMore": "Pročitaj više",
    "discount": "{{value}}% POPUSTA",
    "viewProducts": "Pogledaj proizvode",
    "buyNow": "Kupi sada",
    "topInfluencers": "Naši najprodavaniji",
    "viewShop": "Pogledaj trgovinu",
    "giftCards": "Poklon kartice!",
    "giftCard": "Poklon kartica",
    "giftCardsDescription": "Bilo da želite iznenaditi voljenu osobu, čestitati prijatelju ili pokazati zahvalnost kolegi.",
    "followUs": "Pratite nas",
    "hero": {
      "slide1": {
        "title": "Varga kvaliteta",
        "subtitle": "Po narudžbi izrađujemo i torbe!",
        "cta": "Pogledaj torbe"
      },
      "slide2": {
        "title": "Ogrlice i povodci za pse",
        "subtitle": "Ručno izrađeni kožni dodaci za vaše ljubimce",
        "cta": "Pogledaj ljubimce"
      },
      "slide3": {
        "title": "Postolar Varga papuče",
        "subtitle": "Udobne na svakom koraku",
        "cta": "Pogledaj papuče"
      },
      "slide4": {
        "title": "Unikatan kožni remen",
        "subtitle": "Ručno izrađen od vrhunske kože",
        "cta": "Pogledaj remenje"
      }
    },
    "welcome": {
      "kicker": "Dobrodošli u webshop",
      "title": "Postolar Varga — ručno izrađeni proizvodi od prave kože",
      "subtitle": "Proizvode izrađujemo ručno s pažnjom prema detaljima, a dio asortimana dostupan je po narudžbi i u personaliziranim varijantama. U fokusu su udobnost, trajnost i jedinstven izgled."
    },
    "collections": {
      "anatomskePapuce": "Anatomske papuče",
      "personaliziranePapuce": "Personalizirane papuče",
      "ljetnePapuce": "Ljetne papuče",
      "sandale": "Sandale",
      "torbe": "Torbe",
      "remenje": "Remenje",
      "ljubimci": "Ljubimci"
    },
    "filters": {
      "featured": "Istaknuto",
      "hoodies": "Zimsko",
      "sale": "% Akcija %",
      "influencers": "Novo u ponudi",
      "topSellers": "Najprodavaniji"
    },
    "signUpToNewsletter": {
      "title": "Pretplatite se na naš newsletter",
      "point1": "Dobijte ekskluzivne ponude",
      "point2": "Budite prvi koji će saznati kada nova kolekcija bude objavljena",
      "point3": "Budite u tijeku sa svime što se odnosi na Postolar Varga",
      "inputPlaceholder": "Unesite e-mail adresu",
      "button": "Pretplatite se",
      "subscriptionSuccess": "Pretplata uspješna",
      "subscriptionMessage": "Sada ste dio ekskluzivne grupe koja prima najnovije vijesti, ažuriranja i posebne ponude od našeg tima.",
      "subscriptionError": "Greška u pretplati",
      "consentNote": "Prijavom pristajete na primanje newslettera e-poštom. Odjaviti se možete u svakom trenutku.",
      "privacyLink": "Pravila privatnosti",
      "inputLabel": "E-mail adresa"
    },
    "followUsOnSocial": {
      "title": "Pratite nas",
      "description": "Ostanite povezani s Postolar Varga na društvenim mrežama za najnovija ažuriranja, promocije i nove proizvode.",
      "instagram": "Pratite na Instagramu",
      "facebook": "Pratite na Facebooku"
    },
    "metadata": {
      "title": "Postolar Varga - Ručno rađene anatomske kožne papuče",
      "description": "Proizvodimo visoko-udobne kožne papuče s anatomskim potplatom. Prirodna koža i ručni rad jamče vrhunske anatomske papuče po pristupačnim cijenama."
    },
    "craft": {
      "kicker": "Iz radionice",
      "title": "Svaki par ručno šivamo, sloj po sloj",
      "heelAlt": "Pete dviju papuča Vargice izbliza, ručno šiveni rub i potplat",
      "clogAlt": "Crvena kožna papuča Vargice s kopčom",
      "cta": "Kako ugrađujemo dodatak za petni trn",
      "points": {
        "handmade": {
          "title": "Ručno šivano",
          "body": "Svaku papuču šivamo i sastavljamo ručno, s pažnjom prema udobnosti stopala."
        },
        "insole": {
          "title": "Anatomski uložak",
          "body": "Na potplatu leže memorijska pjena i kožna tabanica, za mekan i stabilan korak."
        },
        "custom": {
          "title": "Prilagodba po narudžbi",
          "body": "Personalizirani modeli, a za ženske veličine 36 do 42 i dodatak za petni trn."
        }
      }
    }
  },
  "Navbar": {
    "loading": "Učitavanje...",
    "links": "Linkovi",
    "searchButton": "Pretraži",
    "products": "Svi proizvodi",
    "collections": "Kolekcije",
    "blog": "Blog",
    "contact": "Kontakt",
    "shopLink": "postolarvarga.hr",
    "electronics": "Elektronika",
    "myAccount": "Moj račun",
    "countries": {
      "croatia": "Hrvatska",
      "serbia": "Srbija",
      "bosnia": "Bosna i Hercegovina",
      "montenegro": "Crna Gora",
      "macedonia": "Sjeverna Makedonija",
      "unitedStates": "SAD",
      "europe": "English (EU)",
      "germany": "Deutsch"
    },
    "ggShopLink": "postolarvarga.hr",
    "selectYourCountry": "Odaberite svoju zemlju",
    "logoutSuccess": "Uspješno ste se odjavili.",
    "search": {
      "placeholder": "Pretraži proizvode...",
      "description": "Pretražite proizvode po nazivu ili marki.",
      "tryThese": "Pokušajte neke od ovih",
      "notFound": "Žao nam je, nismo mogli pronaći ništa za termin \"{{term}}\""
    },
    "profileDropdown": {
      "title": "Moj račun",
      "login": "Prijava",
      "register": "Registrirajte se sada",
      "registerMessage": "{register} i uživajte u ekskluzivnim pogodnostima.",
      "profile": "Profil",
      "orders": "Narudžbe",
      "addresses": "Adrese",
      "returnPolicy": "Politika povrata",
      "paymentOptions": "Načini plaćanja",
      "accountSettings": "Postavke računa",
      "logout": "Odjava"
    }
  },
  "NotFound": {
    "title": "Stranica nije pronađena",
    "subtitle": "404",
    "description": "Ups! Stranica koju tražite ne postoji ili je premještena.",
    "goBack": "Natrag",
    "startOver": "Natrag na početnu",
    "searchProducts": "Pregledaj proizvode"
  },
  "Notice": {
    "order-delay": "Obavijest o kašnjenju narudžbi",
    "order-delay-text": "Zbog povećane potražnje između {{startDate}} i {{endDate}}, obrada narudžbi može potrajati duže nego inače.",
    "order-delay-banner-text": "Obrada narudžbi može kasniti ({{startDate}} - {{endDate}})",
    "okay": "Razumijem"
  },
  "PriceList": {
    "title": "Cjenik",
    "intro": "Cjenik webshopa objavljujemo svaki dan do 8 sati u .csv obliku. Sadrži naziv, šifru, maloprodajnu cijenu, baznu cijenu i dostupnost svakog proizvoda. Prethodne cjenike čuvamo ovdje najmanje 30 dana.",
    "current": "Važeći cjenik",
    "archive": "Arhiva cjenika",
    "published": "Objavljeno {{date}}",
    "download": "Preuzmi",
    "empty": "Cjenik još nije objavljen."
  },
  "ProductsPage": {
    "title": "Proizvodi",
    "count": "{{count}} proizvoda",
    "loadMore": "Učitaj više",
    "emptyTitle": "Nema pronađenih proizvoda",
    "emptySubtitle": "Nismo pronašli proizvode koji odgovaraju vašim kriterijima. Pregledajte ostale kategorije i otkrijte ručno rađene kožene proizvode.",
    "discount": "{value}% POPUSTA",
    "outOfStock": "Nema na zalihi",
    "metadata": {
      "title": "Svi proizvodi - Ručno rađeni koženi proizvodi Postolar Varga",
      "description": "Pregledajte širok izbor anatomskih papuča, sandala, torbi i remenja. Ručno rađeni koženi proizvodi vrhunske kvalitete."
    }
  },
  "Seo": {
    "homepage": {
      "title": "Postolar Varga - Ručno rađene anatomske kožne papuče",
      "description": "Proizvodimo visoko-udobne kožne papuče s anatomskim potplatom. Prirodna koža i ručni rad jamče vrhunske anatomske papuče po pristupačnim cijenama."
    },
    "products": {
      "title": "Svi proizvodi - Postolar Varga",
      "description": "Pregledajte širok izbor anatomskih papuča, sandala, torbi i remenja. Ručno rađeni kožni proizvodi vrhunske kvalitete."
    },
    "product": {
      "title": "{{name}} - Postolar Varga",
      "description": "Kupite {{name}} u Postolar Varga. Vrhunski ručno rađeni kožni proizvodi s dostavom na vašu adresu."
    },
    "collections": {
      "title": "Kolekcije - Postolar Varga",
      "description": "Pregledajte sve kolekcije anatomskih papuča, sandala, torbi, remenja i više."
    },
    "collection": {
      "title": "{{name}} Kolekcija - Postolar Varga",
      "description": "Pregledajte proizvode iz {{name}} kolekcije."
    },
    "cart": {
      "title": "Košarica - Postolar Varga",
      "description": "Pregledajte košaricu i nastavite na naplatu."
    },
    "login": {
      "title": "Prijava - Postolar Varga",
      "description": "Prijavite se na svoj račun za upravljanje narudžbama i praćenje pošiljki."
    },
    "register": {
      "title": "Kreiraj račun - Postolar Varga",
      "description": "Kreirajte novi račun za kupovinu kod nas i uživajte u ekskluzivnim pogodnostima."
    },
    "forgotPassword": {
      "title": "Resetiraj lozinku - Postolar Varga",
      "description": "Resetirajte svoju lozinku za ponovni pristup računu."
    },
    "resetPassword": {
      "title": "Resetiraj lozinku - Postolar Varga",
      "description": "Resetirajte svoju lozinku za ponovni pristup računu."
    },
    "activate": {
      "title": "Aktivirajte račun - Postolar Varga",
      "description": "Aktivirajte svoj račun kako biste mogli kupovati i upravljati narudžbama."
    },
    "faq": {
      "title": "Često postavljana pitanja - Postolar Varga",
      "description": "Pronađite odgovore na česta pitanja o narudžbama, dostavi i povratu."
    },
    "securityAndPrivacy": {
      "title": "Pravila privatnosti - Postolar Varga",
      "description": "Saznajte kako štitimo vaše podatke i privatnost."
    },
    "paymentOptions": {
      "title": "Načini plaćanja - Postolar Varga",
      "description": "Pregledajte dostupne načine plaćanja."
    },
    "returnPolicy": {
      "title": "Pravila povrata - Postolar Varga",
      "description": "Pravila povrata: raskid ugovora u 14 dana, povrat robe i povrat novca."
    },
    "termsOfUse": {
      "title": "Opći uvjeti kupnje - Postolar Varga",
      "description": "Opći uvjeti kupnje u internetskoj trgovini Postolar Varga: narudžba, plaćanje, dostava, raskid ugovora i prigovori."
    },
    "orderingAndDelivery": {
      "title": "Informacije o dostavi - Postolar Varga",
      "description": "Saznajte kako naručiti i kako funkcionira dostava."
    },
    "aboutUs": {
      "title": "O nama - Postolar Varga",
      "description": "Saznajte više o Postolar Vargi, tradiciji ručne izrade kožnih proizvoda i našoj predanosti udobnosti i kvaliteti."
    },
    "notFound": {
      "title": "Stranica nije pronađena - Postolar Varga",
      "description": "Stranica koju tražite ne postoji."
    },
    "account": {
      "title": "Moj račun - Postolar Varga",
      "description": "Upravljajte svojim računom, narudžbama i postavkama."
    },
    "orders": {
      "title": "Moje narudžbe - Postolar Varga",
      "description": "Pregledajte povijest narudžbi i pratite pošiljke."
    },
    "order": {
      "title": "Narudžba #{{id}} - Postolar Varga",
      "description": "Pogledajte detalje narudžbe #{{id}}."
    },
    "addresses": {
      "title": "Moje adrese - Postolar Varga",
      "description": "Upravljajte adresama za dostavu i naplatu."
    },
    "profile": {
      "title": "Moj profil - Postolar Varga",
      "description": "Ažurirajte osobne podatke i postavke."
    },
    "blog": {
      "title": "Blog - Postolar Varga",
      "description": "Savjeti za zdravlje stopala, ortopedska pomagala i anatomsku obuću na blogu Postolar Varga."
    },
    "blogArticle": {
      "title": "{{name}} - Postolar Varga Blog",
      "description": "Pročitajte članak {{name}} na blogu Postolar Varga."
    },
    "withdrawalForm": {
      "title": "Obrazac za raskid ugovora - Postolar Varga",
      "description": "Obrazac za jednostrani raskid ugovora sklopljenog na daljinu, za preuzimanje i ispis."
    },
    "contactInformation": {
      "title": "Kontakt - Postolar Varga",
      "description": "Podaci za kontakt: adresa, e-pošta i telefon Postolar Varga."
    },
    "complaints": {
      "title": "Prigovori i reklamacije - Postolar Varga",
      "description": "Kako podnijeti pisani prigovor ili reklamaciju: osobno, poštom ili e-poštom, s odgovorom u roku od 15 dana."
    },
    "cookies": {
      "title": "Kolačići - Postolar Varga",
      "description": "Koje kolačiće koristimo, zašto, koliko dugo i kako promijeniti ili povući privolu."
    },
    "withdraw": {
      "title": "Raskid ugovora - Postolar Varga",
      "description": "Raskinite ugovor o kupnji putem obrasca, bez prijave. Potvrdu s datumom i vremenom šaljemo e-poštom."
    },
    "priceList": {
      "title": "Cjenik - Postolar Varga",
      "description": "Dnevni cjenik webshopa u .csv obliku s maloprodajnim i baznim cijenama, uz arhivu prethodnih cjenika."
    },
    "legalNotice": {
      "title": "Pravna obavijest - Postolar Varga",
      "description": "Podaci o tvrtki HONOPONO j.d.o.o. (Postolar Varga): sjedište, sudski registar, OIB, temeljni kapital i bankovni račun."
    }
  },
  "SingleProductPage": {
    "legalGuarantee": {
      "trigger": "Vaša prava iz zakonskog jamstva",
      "title": "Zakonsko jamstvo",
      "description": "Usklađena obavijest EU o zakonskom jamstvu usklađenosti",
      "alt": "Usklađena obavijest EU: roba koja se prodaje u Europskoj uniji zaštićena je zakonskim jamstvom od najmanje dvije godine. Ako roba ne odgovara opisu ili ne funkcionira kako je predviđeno, prodavatelj mora ponuditi besplatan popravak ili zamjenu, a u nekim slučajevima sniženje cijene ili povrat novca. Prijavite problem prodavatelju i predočite dokaz o kupnji."
    },
    "priceNote": "Cijena uključuje PDV. Troškovi dostave nisu uključeni.",
    "addToCart": "Dodaj u košaricu",
    "soldOut": "Rasprodano",
    "outOfStock": "Nema na zalihi",
    "notFound": "Proizvod nije pronađen",
    "backToProducts": "Natrag na proizvode",
    "size": "Veličina",
    "color": "Boja",
    "sizeChart": "Tablica veličina",
    "quantity": "Količina",
    "decreaseQuantity": "Smanji količinu",
    "increaseQuantity": "Povećaj količinu",
    "productAddedToCart": "Proizvod dodan u košaricu",
    "close": "Zatvori",
    "description": "Opis",
    "details": "Detalji",
    "vendor": "Marka",
    "type": "Vrsta",
    "relatedProducts": "Možda će vam se svidjeti",
    "breadcrumbs": {
      "home": "Početna",
      "products": "Proizvodi"
    },
    "descriptionAndSpecifications": "Opis i specifikacije",
    "delivery": "Dostava",
    "returns": "Povrati",
    "deliveryText": "Vaša narudžba će biti poslana i isporučena u roku od 7 do 15 radnih dana. Svaka narudžba se obrađuje tek nakon što je naručena. U slučaju neočekivanih kašnjenja, bit ćete obaviješteni e-mailom. Vikendi i praznici se ne ubrajaju u vrijeme potrebno za obradu narudžbi.",
    "returnsText": "Vaše zadovoljstvo je naš prvi prioritet, pa činimo sve što je u našoj moći da vam olakšamo proces kupovine i učinimo ga što ugodnijim. Međutim, ako niste potpuno zadovoljni, možete nam vratiti artikl(e) u roku od 28 dana od primitka, pod uvjetom da su u originalnom stanju.",
    "youMayLike": "Možda će vam se svidjeti",
    "mostPopular": "Najpopularniji",
    "topQuality": "Najviša kvaliteta",
    "cotton100": "100% pamuk",
    "outOfStockNotify": "Obavijesti",
    "outOfStockModal": {
      "title": "Budite u tijeku!",
      "emailContact": "Hvala vam na interesu za naše proizvode. Da biste provjerili dostupnost artikla, molimo pošaljite upit našem posvećenom timu na {email}.",
      "responseInfo": "Primit ćete e-mail obavijest kada ovaj proizvod bude ponovno na zalihi."
    },
    "sizeGuide": {
      "openButton": "Vodič za veličine",
      "title": "Vodič za veličine",
      "description": "Izmjerite duljinu stopala u centimetrima i pronađite odgovarajuću veličinu.",
      "euSize": "EU veličina",
      "footLength": "Duljina stopala",
      "generalTitle": "Standardne veličine",
      "proTitle": "PRO modeli",
      "mensTitle": "Muške veličine"
    },
    "width": "Širina (cm)",
    "height": "Visina (cm)",
    "optionName": {
      "Size": "Veličina",
      "Color": "Boja",
      "Material": "Materijal",
      "Style": "Stil",
      "Shoe size": "Veličina",
      "Dodatak": "Dodatak",
      "Title": "Naslov"
    },
    "manufacturer": "Proizvođač",
    "manufacturerCountry": "Hrvatska",
    "productCode": "Šifra proizvoda",
    "materials": {
      "title": "Materijali",
      "upper": "Gornji dio",
      "upperValue": "prava koža",
      "lining": "Podstava",
      "liningValue": "brušena koža",
      "sole": "Potplat",
      "soleValue": "poliuretan"
    },
    "safety": {
      "title": "Sigurnosne informacije",
      "use": "Obuća za odrasle, za nošenje u zatvorenom i na otvorenom. Nije namijenjena sportu.",
      "water": "Ne izlažite je vodi, kiši ni kemikalijama.",
      "sole": "Potplat od poliuretana može biti sklizak na mokrim i glatkim podovima.",
      "metal": "Kopča i nitne su metalne i mogu sadržavati tragove nikla.",
      "smallParts": "Sitne ukrase držite dalje od male djece i kućnih ljubimaca.",
      "heat": "Čuvajte je dalje od otvorenog plamena i izravnih izvora topline."
    },
    "safetyGoods": {
      "metal": "Metalni dijelovi mogu sadržavati tragove nikla.",
      "water": "Ne izlažite ga vodi, kiši ni kemikalijama.",
      "heat": "Čuvajte ga dalje od otvorenog plamena i izravnih izvora topline."
    }
  },
  "Withdrawal": {
    "title": "Raskid ugovora",
    "intro": "Ugovor o kupnji možete raskinuti u roku od 14 dana od primitka pošiljke, bez navođenja razloga. Upišite podatke iz narudžbe, provjerite ih i potvrdite raskid.",
    "fields": {
      "name": "Ime i prezime",
      "orderNumber": "Broj narudžbe",
      "orderNumberHint": "Piše u potvrdi narudžbe, npr. 1124.",
      "email": "E-pošta iz narudžbe",
      "emailHint": "Na nju šaljemo potvrdu primitka s datumom i vremenom."
    },
    "continue": "Nastavi",
    "back": "Natrag",
    "reviewTitle": "Provjerite izjavu o raskidu",
    "statement": "Ovim izjavljujem da raskidam ugovor o kupnji sljedeće robe iz narudžbe {{order}}:",
    "summary": {
      "name": "Ime i prezime",
      "order": "Narudžba",
      "email": "E-pošta"
    },
    "confirm": "Potvrdi raskid ugovora",
    "confirmNote": "Potvrdu primitka s datumom i vremenom poslat ćemo na {{email}}.",
    "doneTitle": "Izjava o raskidu je zaprimljena",
    "doneBody": "Zaprimili smo vašu izjavu o raskidu ugovora za narudžbu {{order}}. Potvrdu s datumom i vremenom poslali smo na {{email}}. O daljnjim koracima obavijestit ćemo vas e-poštom.",
    "errors": {
      "NOT_FOUND": "Ne pronalazimo narudžbu s tim brojem i e-poštom. Provjerite podatke u potvrdi narudžbe.",
      "CANCELLED": "Ova je narudžba već otkazana.",
      "NOTHING_TO_WITHDRAW": "U ovoj narudžbi više nema robe za povrat. Ako mislite da je to greška, pišite nam na postolar.varga@gmail.com.",
      "REQUEST_FAILED": "Raskid za ovu narudžbu ne možemo zaprimiti putem obrasca, možda je već podnesen. Pišite nam na postolar.varga@gmail.com.",
      "SERVER_ERROR": "Nešto nije u redu. Pokušajte ponovno ili nam pišite na postolar.varga@gmail.com.",
      "INVALID": "Provjerite upisane podatke."
    },
    "otherWays": {
      "start": "Raskid možete podnijeti i u svom",
      "account": "korisničkom računu",
      "middle": "ili nam poslati",
      "form": "obrazac za raskid ugovora",
      "end": "e-poštom ili poštom."
    }
  }
}